import React from 'react';
import clsx from 'clsx';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import moment from 'moment-timezone';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import { MenuItem, Select } from '@material-ui/core';
import qs from 'query-string';
import classNames from 'classnames';
import SearchButton from '../../components/atoms/SearchButton';
import MenuRegisterButton from '../../components/atoms/MenuRegisterButton';
import MenuViewOrderEditButton from '../../components/atoms/MenuViewOrderEditButton';
import CsvDownloadButton from '../../components/atoms/CsvDownloadButton';
import MenuViewOrderCustom from '../organisms/MenuViewOrderCustom';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getGochiMenus,
  getOrderGochiMenus,
  downloadMenu
} from '../../actions/GochiMenus';
import { getAccounts } from '../../actions/Accounts';
import { getShops } from '../../actions/Shop';
import {
  getOptionShops,
  getMenuGenreOption,
  getMenuSituationOption,
  getMenuUserTargetOption
} from '../../actions/Options';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import GochiMenuTableGroup from '../organisms/GochiMenuTableGroup';
import GochiMenuAddGroup from '../organisms/GochiMenuAddGroup';
import listMenuSystemFlags from '../../constants/MenuSystemFlags';
import GochiMenuAddChooseUsageTypeGroup from '../organisms/GochiMenuAddChooseUsageTypeGroup';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: '20px 0px',
    minWidth: 1024
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  // textField: {
  //   marginTop: 10
  // },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10,
    color: '#000000'
  },
  rowForm: {
    display: 'flex',
    marginLeft: '-5px',
    marginRight: '-5px',
    flexWrap: 'wrap'
  },
  formControl: {
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: 15,
    width: '20%'
  },
  textField: {
    position: 'relative'
  },
  noPaddingCell: {
    padding: 0,
    border: 'none',
    paddingRight: 5,
    maxWidth: 200,
    minWidth: 200,
    verticalAlign: 'initial'
  },
  buttonGroupLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  tableContainer: {
    position: 'relative',
    marginTop: 15,
    paddingTop: 10
  },
  buttonGroupRight: {
    position: 'absolute',
    top: 0,
    right: 0
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  toolbar: {
    display: 'flex',
    fontSize: 24,
    fontWeight: 'bold'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)',
    minWidth: 1024
  },
  formLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#000'
  },
  textInput: {
    height: 1
  },
  buttonSearch: {
    margin: '22px 0 0 10px',
    height: 38
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  selectInput: {
    backgroundColor: '#FFF !important'
  },
  select: {
    width: '100%',
    // height: 38,
    height: '52%',
    // marginTop: 10,
    display: 'flex',
    backgroundColor: '#FFF'
  },
  modalChooseUsageType: {
    maxWidth: 1153
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      showHides: state.gochiMenus.showHide.map(el =>
        el.id === '' ? { ...el, name: '選択してください' } : el
      ),
      menuChildTypes: state.gochiMenus.menuChildType,
      menuGenre: state.options.listMenuGenre,
      menuSituation: state.options.listMenuSituation,
      menuUserTarget: state.options.listMenuUserTarget
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getOrderGochiMenus,
          downloadMenu,
          getAccounts,
          getShops,
          getOptionShops,
          getMenuGenreOption,
          getMenuSituationOption,
          getMenuUserTargetOption
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openAddChooseUsageType', 'updateOpenAddChooseUsageType', false),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openViewOrderCustom', 'updateOpenViewOrderCustom', false),
  withState('openViewOrderCustomList', 'updateOpenViewOrderCustomList', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('orderMenuShopId', 'setOrderMenuShopId', ''),
  withState('groupName', 'setGroupName', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopId', 'setShopId', null),
  withState('menuName', 'setMenuName', ''),
  withState('menuId', 'setMenuId', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('showHide', 'setShowHide', ''),
  withState('menuChildType', 'setMenuChildType', ''),
  withState('menuGenre', 'setMenuGenre', []),
  withState('menuSituation', 'setMenuSituation', []),
  withState('menuUserTarget', 'setMenuUserTarget', []),
  withState('menuSystemFlag', 'setMenuSystemFlag', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit, params) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 15;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        groupName: props.groupName,
        shopName: props.shopName,
        menuName: props.menuName,
        shopId: props.shopId,
        menuId: props.menuId,
        showHide: props.showHide,
        menuChildType: props.menuChildType,
        menuSystemFlag: props.menuSystemFlag,
        page,
        limit: limitNum,
        ...params
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getGochiMenus(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (
            data.type !== 'GET_GOCHI_MENUS_SUCCESS' &&
            data.payload.status === 400
          ) {
            alert('失敗しました');
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      const url = window.location.search;
      const { shopId } = qs.parse(url);
      this.props.setShopId(shopId);
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.updateOpenTable(true);
        this.props.handleChangePage(null, 1, this.props.rowsPerPage, {
          shopId
        });
      });
      this.props.actions.getMenuGenreOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuGenre(data.payload);
      });
      this.props.actions.getMenuSituationOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuSituation(data.payload);
      });
      this.props.actions.getMenuUserTargetOption().then(data => {
        this.props.checkSession(data);
        this.props.setMenuUserTarget(data.payload);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    account,
    openTable,
    updateOpenTable,
    openAdd,
    updateOpenAdd,
    openAddChooseUsageType,
    updateOpenAddChooseUsageType,
    openAddConfirm,
    updateOpenAddConfirm,
    openViewOrderCustom,
    updateOpenViewOrderCustom,
    openViewOrderCustomList,
    updateOpenViewOrderCustomList,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    shopId,
    setShopId,
    orderMenuShopId,
    setOrderMenuShopId,
    groupName,
    // setGroupName,
    shopName,
    setShopName,
    menuName,
    setMenuName,
    menuId,
    setMenuId,
    resultMessage,
    setResultMessage,
    page,
    showHide,
    menuChildType,
    setShowHide,
    setMenuChildType,
    showHides,
    menuChildTypes,
    menuGenre,
    menuSituation,
    menuUserTarget,
    menuSystemFlag,
    setMenuSystemFlag
  }) => {
    const isChildShop =
      typeof account !== 'undefined' &&
      account.role === 'SHOP' &&
      ((account.belongToChildGroups !== 'undefined' &&
        account.belongToChildGroups.length > 0) ||
        account.childShopFlag === 1);
    const isChildGroup =
      typeof account !== 'undefined' &&
      account.role === 'GROUP' &&
      (account.groupType !== null &&
        account.groupType.toUpperCase() === 'OTHERS');
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const roles = {
      isChildShop,
      isChildGroup,
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 15;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      groupName,
      shopName,
      menuName,
      shopId,
      menuId,
      showHide,
      menuChildType,
      menuSystemFlag,
      page,
      limit: limitNum
    };
    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };

    const addAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const shopData = await actions
        .getOptionShops()
        .then(data => checkSession(data));
      if (shopData.type === 'GET_SHOPS_SUCCESS') {
        if (!shopId) {
          const initialShopId = isShop ? shopData.payload.list[0].shopId : null;
          setShopId(initialShopId);
        }
        updateOpenProgress(false);
        updateLoading(false);
        if (isFukuoka) {
          updateOpenAdd(true);
        } else {
          updateOpenAddChooseUsageType(true);
        }
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const viewOrderCustomAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const shopData = await actions
        .getShops()
        .then(data => checkSession(data));
      if (shopData.type === 'GET_SHOPS_SUCCESS') {
        if (!orderMenuShopId) {
          const initialOrderMenuShopId = isShop
            ? shopData.payload.shops[0].shopId
            : 0;
          setOrderMenuShopId(initialOrderMenuShopId);
        }
        updateOpenProgress(false);
        updateLoading(false);
        updateOpenViewOrderCustom(true);
      } else {
        updateOpenProgress(false);
        updateLoading(false);
      }
    };

    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();
        linkEl.parentNode.removeChild(linkEl);
        // iOSのクリックイベント対策
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .downloadMenu(searchKey)
        .then(data => checkSession(data));
      if (response.type === 'DOWNLOAD_GOCHI_MENU_SUCCESS') {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setResultMessage('');
        updateLoading(false);
        let csvName = `${timeStamp}_gochi_menu_info.csv`;
        if (typeof account !== 'undefined' && account.fukuokaFlag === 1) {
          csvName = `${timeStamp}_course_info.csv`;
        }
        downloadCsvBlob(response.payload, csvName);
      } else {
        setResultMessage('メニュー情報ダウンロードに失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };
    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="メニュー情報" />
        <main className={classes.content}>
          <div className={classes.toolbar}>
            {isFukuoka ? 'コース情報' : 'メニュー情報'}
          </div>
          <Paper className={classes.mainPaper} elevation={1}>
            <div className={classes.searchForm}>
              <div className={classes.rowForm}>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? 'コース表示' : 'メニュー表示'}
                  </FormLabel>
                  <Select
                    className={classes.select}
                    value={showHide}
                    onChange={e => {
                      setShowHide(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    displayEmpty
                    variant="outlined"
                    fullWidth
                    inputProps={{ className: classes.height1 }}
                  >
                    {showHides.map(item => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                {!isFukuoka && (
                  <>
                    <FormControl
                      className={clsx(classes.margin, classes.formControl)}
                      variant="outlined"
                      size="small"
                    >
                      <FormLabel className={classes.subTitle}>
                        メニュー種別
                      </FormLabel>
                      <Select
                        select
                        displayEmpty
                        className={classes.select}
                        defaultValue=""
                        margin="normal"
                        value={menuChildType}
                        onChange={e => {
                          setMenuChildType(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                        variant="outlined"
                        // fullWidth
                        size="small"
                        inputProps={{
                          className: classes.selectInput
                        }}
                      >
                        <MenuItem key="" value="">
                          選択してください
                        </MenuItem>
                        {menuChildTypes.map(item => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl
                      className={clsx(classes.margin, classes.formControl)}
                      variant="outlined"
                      size="small"
                    >
                      <FormLabel className={classes.subTitle}>
                        利用用途
                      </FormLabel>
                      <Select
                        select
                        displayEmpty
                        className={classes.select}
                        defaultValue=""
                        margin="normal"
                        value={menuSystemFlag}
                        onChange={e => {
                          setMenuSystemFlag(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true
                        }}
                        variant="outlined"
                        // fullWidth
                        size="small"
                        inputProps={{
                          className: classes.selectInput
                        }}
                      >
                        {listMenuSystemFlags.map(item => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </>
                )}
              </div>

              <div className={classes.rowForm}>
                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? '教室ID' : '店舗ID'}
                  </FormLabel>
                  <TextField
                    placeholder="例) 0123"
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={shopId}
                    onChange={e => {
                      setShopId(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? '教室名' : '店舗名'}
                  </FormLabel>
                  <TextField
                    placeholder={
                      isFukuoka ? '例）Gigi〇〇校' : '例) Gigi 〇〇店'
                    }
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={shopName}
                    onChange={e => {
                      setShopName(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? 'コースID' : 'メニューID'}
                  </FormLabel>
                  <TextField
                    placeholder="例) 0123"
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={menuId}
                    onChange={e => {
                      setMenuId(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </FormControl>

                <FormControl
                  className={clsx(classes.margin, classes.formControl)}
                  variant="outlined"
                  size="small"
                >
                  <FormLabel className={classes.subTitle}>
                    {isFukuoka ? 'コース名' : 'メニュー名'}
                  </FormLabel>
                  <TextField
                    placeholder={
                      isFukuoka ? '例）Gigi〇〇コース' : '例) とんかつ定食'
                    }
                    type="search"
                    className={classes.textField}
                    variant="outlined"
                    size="small"
                    value={menuName}
                    onChange={e => {
                      setMenuName(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                </FormControl>

                <SearchButton
                  customStyles={classes.buttonSearch}
                  onClickAction={searchAction}
                />
              </div>
            </div>
          </Paper>

          {openTable && (
            <div className={classes.tableContainer}>
              <div className={classes.buttonGroupLeft} />
              <div className={classes.buttonGroupRight}>
                <MenuViewOrderEditButton
                  onClickAction={viewOrderCustomAction}
                  isFukuoka={isFukuoka}
                />
                <CsvDownloadButton onClickAction={csvDownloadAction} />
                {(account.groupType !== 'OTHERS' || isFukuoka) && (
                  <MenuRegisterButton
                    onClickAction={addAction}
                    btnText={isFukuoka ? 'コース追加' : 'メニュー追加'}
                  />
                )}
              </div>
              <GochiMenuTableGroup
                searchKey={searchKey}
                roles={roles}
                progress={progress}
                page={page}
                handleChangePage={handleChangePage}
                selectedPage={page}
                updateLoading={updateLoading}
                updateOpenProgress={updateOpenProgress}
                menuGenre={menuGenre}
                menuSituation={menuSituation}
                menuUserTarget={menuUserTarget}
                isFukuoka={isFukuoka}
              />

              <div>
                <Modal open={openAdd} className={classes.modal}>
                  <GochiMenuAddGroup
                    openAddConfirm={openAddConfirm}
                    updateOpenAdd={updateOpenAdd}
                    updateOpenAddConfirm={updateOpenAddConfirm}
                    searchKey={searchKey}
                    shopId={shopId}
                    setShopId={setShopId}
                    roles={roles}
                    onAddGochiMenuSuccess={() =>
                      handleChangePage(null, page, rowsPerPage)
                    }
                    menuGenre={menuGenre}
                    menuSituation={menuSituation}
                    menuUserTarget={menuUserTarget}
                    isFukuoka={isFukuoka}
                  />
                </Modal>
              </div>

              <div>
                <Modal
                  open={openAddChooseUsageType}
                  className={classNames(
                    classes.modalChooseUsageType,
                    classes.modal
                  )}
                >
                  <GochiMenuAddChooseUsageTypeGroup
                    updateOpenAddChooseUsageType={updateOpenAddChooseUsageType}
                    openAddChooseUsageType={openAddChooseUsageType}
                    searchKey={searchKey}
                    shopId={shopId}
                    setShopId={setShopId}
                    onAddGochiMenuSuccess={() =>
                      handleChangePage(null, page, rowsPerPage)
                    }
                    menuGenre={menuGenre}
                  />
                </Modal>
              </div>

              <div>
                <Modal open={openViewOrderCustom} className={classes.modal}>
                  <MenuViewOrderCustom
                    updateOpenViewOrderCustom={updateOpenViewOrderCustom}
                    openViewOrderCustomList={openViewOrderCustomList}
                    updateOpenViewOrderCustomList={
                      updateOpenViewOrderCustomList
                    }
                    orderMenuShopId={orderMenuShopId}
                    setOrderMenuShopId={setOrderMenuShopId}
                    searchKey={searchKey}
                    isFukuoka={isFukuoka}
                  />
                </Modal>
              </div>
            </div>
          )}
        </main>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
